import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroTrash } from '@ng-icons/heroicons/outline';
import { CompanyService } from 'src/app/api/services/company.service';
import { LoadingButtonComponent } from 'src/app/shared/component/loading-button/loading-button.component';
import { ToastService } from 'src/app/shared/service/toast.service';

@Component({
  selector: 'app-home-admin',
  imports: [NgIcon, LoadingButtonComponent, CommonModule],
  templateUrl: './home-admin.component.html',
  viewProviders: provideIcons({ heroTrash }),
})
export class HomeAdminComponent {
  showConfirmDelete: boolean = false;
  loadingDelete: boolean = false;

  constructor(
    private companyService: CompanyService,
    private toastService: ToastService
  ) {}

  openDeleteModal() {
    this.showConfirmDelete = true;
  }

  closeDeleteModal() {
    this.showConfirmDelete = false;
  }

  confirmDelete() {
    this.loadingDelete = true;
    this.companyService.removeAllInactiveCompanies().subscribe({
      next: (res) => {
        this.toastService.showMessages('success', [res.listMessage]);
        this.closeDeleteModal();
      },
      error: () => {
        this.toastService.showMessages('error', [
          'Error al eliminar las compañías no verificadas.',
        ]);
      },
      complete: () => {
        this.loadingDelete = false;
      },
    });
  }
}
